import { render, staticRenderFns } from "./ProductDetailsCard.vue?vue&type=template&id=fd2401fa&scoped=true"
import script from "./ProductDetailsCard.vue?vue&type=script&lang=js"
export * from "./ProductDetailsCard.vue?vue&type=script&lang=js"
import style0 from "./ProductDetailsCard.vue?vue&type=style&index=0&id=fd2401fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd2401fa",
  null
  
)

export default component.exports